import { useRef } from "react";
import { toPng } from "html-to-image";
import AdCard from "./AdCard";
import Vector1 from "../../assets/images/Vector1.png";

export default function AdTemplatePage() {
  const captureRef = useRef(null);

  const handleDownload = async () => {
    if (captureRef.current) {
      const dataUrl = await toPng(captureRef.current, {
        cacheBust: true,
        backgroundColor: "transparent",
      });

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "ad-card.png";
      link.click();
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 p-8  min-h-screen">
      <button
        onClick={handleDownload}
        className="px-4 py-2 bg-indigo-600 text-white rounded-lg shadow"
      >
        이미지 다운로드
      </button>
      <div ref={captureRef}>
        <AdCard
          rank="1st"
          title="Over 95% of the users IMPROVE CTR"
          subtitle="Ad created with AdCreative.ai"
          ctaText="Try for Free Now"
          image={Vector1}
          bgimage="https://i.pinimg.com/736x/09/3d/e8/093de8e08ce331dc133eb3bb39f0d3fb.jpg"
          themeColor="#231942"
        />
      </div>
    </div>
  );
}
